import axios from 'axios';

const API_URL = 'https://resolvebo.innovationcode.pro/api';
// const API_URL = 'http://localhost:5282/api';

const claimAttachmentsService = {

    getAttachments: async (trackingNumber) => {
        // Vérifier que trackingNumber est valide
        if (!trackingNumber) {
            console.error('Erreur: trackingNumber est requis pour récupérer les pièces jointes');
            throw new Error('Numéro de suivi manquant');
        }

        try {
            const response = await axios.get(`${API_URL}/claims/${trackingNumber}/attachments`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des pièces jointes:', error);
            throw error;
        }
    },


    addAttachments: async (trackingNumber, files) => {
        // Vérifier que trackingNumber est valide
        if (!trackingNumber) {
            console.error('Erreur: trackingNumber est requis pour ajouter des pièces jointes');
            throw new Error('Numéro de suivi manquant');
        }

        // Vérifier que files contient des fichiers
        if (!files || files.length === 0) {
            console.error('Erreur: aucun fichier fourni');
            throw new Error('Aucun fichier à ajouter');
        }

        try {
            const formData = new FormData();

            // Ajouter chaque fichier à FormData
            Array.from(files).forEach(file => {
                formData.append('attachments', file);
            });

            const response = await axios.post(
                `${API_URL}/claims/${trackingNumber}/attachments`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'ajout des pièces jointes:', error);
            throw error;
        }
    },


    getDownloadUrl: (trackingNumber, attachmentId) => {
        if (!trackingNumber || !attachmentId) {
            console.error('Erreur: trackingNumber et attachmentId sont requis');
            return '#'; // URL invalide pour éviter une requête erronée
        }
        return `${API_URL}/claims/${trackingNumber}/attachments/${attachmentId}`;
    },

    deleteAttachment: async (trackingNumber, attachmentId) => {
        if (!trackingNumber || !attachmentId) {
            console.error('Erreur: trackingNumber et attachmentId sont requis');
            throw new Error('Paramètres manquants');
        }

        try {
            const response = await axios.delete(`${API_URL}/claims/${trackingNumber}/attachments/${attachmentId}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la suppression de la pièce jointe:', error);
            throw error;
        }
    },

    getDownloadUrl: (trackingNumber, attachmentId) => {
        if (!trackingNumber || !attachmentId) {
            console.error('Erreur: trackingNumber et attachmentId sont requis');
            return '#'; // URL invalide pour éviter une requête erronée
        }
        return `${API_URL}/claims/${trackingNumber}/attachments/${attachmentId}`;
    },

    getPreviewUrl: (trackingNumber, attachmentId) => {
        if (!trackingNumber || !attachmentId) {
            console.error('Erreur: trackingNumber et attachmentId sont requis');
            return '#'; // URL invalide pour éviter une requête erronée
        }
        return `${API_URL}/claims/${trackingNumber}/attachments/${attachmentId}/preview`;
    },

    isPreviewable: (fileName) => {
        if (!fileName) return false;

        const extension = fileName.split('.').pop().toLowerCase();
        const previewableExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];

        return previewableExtensions.includes(extension);
    }


};

export default claimAttachmentsService;